<template>
  <v-dialog v-model="dialog" persistent max-width="290">
      <!-- <slot name="activator">
          <v-btn text slot="activator">{{ $t('screener.header.change.language.title') }}</v-btn>
      </slot> -->
      <v-list-tile-title slot="activator">{{ $t('screener.header.change.language.title') }}</v-list-tile-title>
      <v-card>
        <v-card-title class="subheading">
          {{ $t('screener.header.change.language.title') }}
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false"  icon small>
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list>
            <div v-for="(item, index) in enabledLanguages" :key="index">
              <v-list-tile @click="changeLocale(item.value)">
                <v-list-tile-content>
                  <v-list-tile-title :class="[item.value == currentLanguage ? 'primary--text' : '']">
                    {{ item.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="item.value == currentLanguage">
                  <v-icon color="success">mdi-check</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider></v-divider>
            </div>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
import {mapGetters, mapState} from 'vuex'
export default {
  name: "ChangeLanguageDialog",
  data() {
      return {
          dialog: false
      }
  },
  computed: {
    ...mapGetters("app", {
        currentLanguage: "getCurrentLanguage",
    }),
    ...mapState({
      company: (state) => state.company.company,
    }),
    enabledLanguages() {
      if (this.company) {
          return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : DEFINES.LOCALES; 
      }else{
          return DEFINES.LOCALES
      }
    }
  },
  methods: {
      async changeLocale(value) {
          await this.$store.dispatch("app/updateLocale", {
              locale: value,
          });
          this.dialog = false;
      },
  }
}
</script>
